// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { categoriesStyles } from "@guestsupply/Overrides/Widgets/BrandDetails/BrandDetailsCategories";

import categoryItemSharedStyles from "@guestsupply/App/SharedStyles/categoryItemSharedStyles";
import { color } from "@guestsupply/XDL/Utilities";
import { css } from "styled-components";

categoriesStyles.title = {
    variant: "h4",
    weight: 500,
    css: css`
        margin-bottom: 20px;
        padding-bottom: 5px;
        border-bottom: 1px solid ${color("common.border")};
    `,
};
categoriesStyles.container = {
    ...categoryItemSharedStyles.container,
};

categoriesStyles.subCategoryItem = {
    ...categoryItemSharedStyles.categoryItem,
};

categoriesStyles.categoryContainer = {
    ...categoryItemSharedStyles.categoryContainer,
};

categoriesStyles.innerContainer = {
    ...categoryItemSharedStyles.innerContainer,
};

categoriesStyles.subCategoryImageClickable = {
    ...categoryItemSharedStyles.categoryImageLink,
};

categoriesStyles.subCategoryImage = {
    ...categoryItemSharedStyles.categoryImage,
};

categoriesStyles.subCategoryNameLink = {
    ...categoryItemSharedStyles.subCategoryNameLink,
};

categoriesStyles.categoryHeader = {
    ...categoryItemSharedStyles.categoryHeader,
};

categoriesStyles.viewMoreLinkWrapper = {
    ...categoryItemSharedStyles.viewMoreLinkItem,
};

categoriesStyles.viewMoreLink = {
    ...categoryItemSharedStyles.viewMoreLink,
};
